import apiHandler from "../core/apiHandler";

/**
 * 💵 API para el reporte de propina por mes
 * Endpoint: /api/reports/tips
 */
const tipReportApi = apiHandler("reports/tips");

export default tipReportApi;
